export function quoteGeneration(request, model) {
  const pricing = model?.pricing || {};
  const currency = pricing.currency || null;
  const rates = Object.entries(pricing).filter(([key,value]) => key !== 'currency' && value !== null && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0)
    .map(([key,value]) => ({key,rate:Number(value),unit:model?.pricing_units?.[key] || null}));
  if (!currency || !rates.length) return {status:'unavailable',currency,basis:'Pricing is unavailable; total cannot be estimated.'};
  const image = rates.find(r => r.key === 'completionImageTokens');
  if (model.flat_rate === true && image && rates.length === 1 && !image.unit && !model.pricing_dimensions && !model.pricing_variants) {
    return {status:'estimate',currency,total:image.rate * request.outputCount,perOutput:image.rate,basis:'Flat rate per image',outputCount:request.outputCount};
  }
  return {status:'unit-only',currency,rates,basis:'Usage-based pricing; total is unknown before generation.'};
}
export function formatPrice(number) {
  return Number(number).toLocaleString('en-US',{maximumSignificantDigits:10,useGrouping:false});
}
export function quoteLabel(quote, ar = false) {
  if (quote?.status === 'estimate') return `${ar ? 'التكلفة التقديرية' : 'Estimated total'}: ${formatPrice(quote.total)} ${quote.currency}`;
  if (quote?.status === 'unit-only') return `${ar ? 'الإجمالي غير معروف مسبقاً' : 'Total unknown before generation'} · ${quote.rates.map(r => `${formatPrice(r.rate)} ${quote.currency} / ${r.unit ? `${r.unit.unit} (quantity ${r.unit.quantity ?? '?'})` : r.key.replace(/Tokens$/, ' token')}`).join(' · ')}`;
  return ar ? 'السعر غير متاح؛ الإجمالي غير معروف.' : 'Pricing unavailable; total unknown.';
}
